<h4 class="db-cdn-feature-stack__title">Cloudflare feature-stack</h4>
<p class="db-cdn-feature-stack__desc mb25">Here are the features available to you as part of Cloudflare Enterprise solution</p>

<div class="db-cdn-feature-stack__card mb10">
  <div>
    <h5 class="db-cdn-feature-stack__title">Enterprise CDN</h5>
    <p class="db-cdn-feature-stack__desc">All static content (such as images, CSS, and JavaScript files) will load through Cloudflare CDN.</p>
  </div>

  <div class="relative">
    <input class="ds-switcher-green ds-control-small" type="checkbox" id="cdn" [disabled]="loading || isStatusPending" [checked]="!cdnDisabled"
           [ngModel]="!cdnDisabled" (ngModelChange)="cdnDisabled = $event">
    <label for="cdn" (click)="toggleCDN(); $event.preventDefault()">
      <span class="ds-switcher-control"></span>
    </label>
    <div *ngIf="showEntCDNTooltip" class="db-cdn-static-tooltip top" #CDNEnableTooltip>
      <p class="mb10">The changes will be applied within 1 minute.</p>
      <p class="text-right" (click)="showEntCDNTooltip = false"><b>Got It</b></p>
    </div>
  </div>


</div>

<div class="db-cdn-feature-stack__card mb10">
  <div>
    <h5 class="db-cdn-feature-stack__title">Full page cache</h5>
    <p class="db-cdn-feature-stack__desc">Cache the HTML content of your pages.</p>
  </div>

  <div *ngIf="!cdnDisabled && !isStatusPending; else cdnDisabledView">
    <input class="ds-switcher-green ds-control-small" type="checkbox" id="pageCache" [disabled]="loading || isStatusPending" [checked]="!pageCacheDisabled"
           [ngModel]="!pageCacheDisabled" (ngModelChange)="pageCacheDisabled = $event">
    <label for="pageCache" (click)="togglePageCache(); $event.preventDefault()">
      <span class="ds-switcher-control"></span>
    </label>
  </div>

  <ng-template #cdnDisabledView>
    <p class="db-cdn-feature-stack__text-bold">Enable Enterprise CDN to apply full page cache</p>
  </ng-template>
</div>

<div class="db-cdn-feature-stack__grid">
  <div *ngFor="let feature of features" class="db-cdn-feature-stack__card">
    <p class="db-cdn-feature-stack__text-bold" [innerHTML]="feature"></p>
    <i class="db-icon db-icon-ds-checkmark-bg checkmark" [ngClass]="{'disabled': isStatusPending}"></i>
  </div>
</div>
